"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeysRdfResolveHypermediaLinks = void 0;
const core_1 = require("@comunica/core");
/**
 * When adding entries to this file, also add a shortcut for them in the contextKeyShortcuts TSDoc comment in
 * ActorIniQueryBase in @comunica/actor-init-query if it makes sense to use this entry externally.
 * Also, add this shortcut to IQueryContextCommon in @comunica/types.
 */
exports.KeysRdfResolveHypermediaLinks = {
    /**
     * A flag for indicating if traversal should be enabled. Defaults to true.
     */
    traverse: new core_1.ActionContextKey('@comunica/actor-rdf-resolve-hypermedia-links-traverse:traverse'),
    /**
     * Context entry for indicating the type of source annotation.
     */
    annotateSources: new core_1.ActionContextKey('@comunica/bus-rdf-resolve-hypermedia-links:annotateSources'),
};
//# sourceMappingURL=Keys.js.map